
function toggleSummaryBullets() {
    var bullets = document.querySelector('.ProductMeta__SummaryBullets'),
        button = document.querySelector('.ProductMeta__ReadMore');
    
    if (bullets) {
        if (bullets.querySelectorAll('li').length > 3) {
            var moreText = button.innerText,
                lessText = button.dataset.lessText;
    
            button.addEventListener('click', function() {
                this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true' );
                this.innerText = this.getAttribute('aria-expanded') === 'true' ? lessText : moreText;
                bullets.classList.toggle('ProductMeta__SummaryBullets--all');
            });
        } else {
            button.style.display = 'none';
        }
    }
}

function toggleVariantThumbnails() {
    const product = document.querySelector('.Product');

    if (!product) {
        return;
    }

    const slideshowElement = product.querySelector('.Product__Slideshow');
    const thumbnailNav = product.querySelector('.Product__SlideshowNav--thumbnails');

    if (!slideshowElement || !thumbnailNav) {
        return;
    }

    const targetOption = product.dataset.changeImageOption;
    const thumbnails = Array.from(thumbnailNav.querySelectorAll('.Product__SlideshowNavImage'));
    const dots = Array.from(product.querySelectorAll('.Product__SlideshowMobileNav .dot'));
    const slides = Array.from(slideshowElement.querySelectorAll('.Product__SlideItem'));
    const pocketViewport = window.matchMedia('(max-width: 1007px)');
    let activeVariant = {
        colorName: thumbnailNav.dataset.selectedColor,
        sku: thumbnailNav.dataset.selectedSku,
        featuredMediaId: thumbnailNav.dataset.selectedMediaId || null
    };
    let slideshowListenerAttached = false;
    let variantUpdateFrame = null;
    let galleryLayoutFrame = null;

    const normalizeOptionValue = function(value) {
        return (value || '').replace(/\s+/g, '').replace(/\//g, '').toLowerCase();
    };

    const scheduleGalleryUpdate = function(variant, colorName) {
        activeVariant = {
            colorName: normalizeOptionValue(colorName),
            sku: (variant && variant.sku || '').toLowerCase(),
            featuredMediaId: variant && variant.featured_media ? String(variant.featured_media.id) : null
        };

        if (variantUpdateFrame) {
            window.cancelAnimationFrame(variantUpdateFrame);
        }

        variantUpdateFrame = window.requestAnimationFrame(function() {
            updateGallery(activeVariant.colorName, activeVariant.sku, activeVariant.featuredMediaId, true);
            variantUpdateFrame = null;
        });
    };

    const matchesVariant = function(element, colorName, variantSku) {
        const imageVariant = (element.dataset.imageVariant || '').toLowerCase();
        return imageVariant === colorName || imageVariant === variantSku;
    };

    const getProductSlideshow = function() {
        return Flickity.data(slideshowElement);
    };

    const replaceSlides = function(visibleSlides, selectedMediaId) {
        const productSlideshow = getProductSlideshow();

        if (!productSlideshow) {
            return;
        }

        const currentSlides = productSlideshow.cells.map(function(cell) {
            return cell.element;
        });

        if (currentSlides.length) {
            productSlideshow.remove(currentSlides);
        }

        productSlideshow.append(visibleSlides);

        const selectedIndex = visibleSlides.findIndex(function(slide) {
            return slide.dataset.mediaId === selectedMediaId;
        });
        const targetIndex = selectedIndex >= 0 ? selectedIndex : 0;

        productSlideshow.options.draggable = visibleSlides.length > 1;

        if (productSlideshow.options.draggable) {
            productSlideshow.bindDrag();
        } else {
            productSlideshow.unbindDrag();
        }

        productSlideshow.select(targetIndex, false, true);
        productSlideshow.positionSliderAtSelected();
        productSlideshow.resize();

        if (galleryLayoutFrame) {
            window.cancelAnimationFrame(galleryLayoutFrame);
        }

        galleryLayoutFrame = window.requestAnimationFrame(function() {
            // iOS Safari needs a second layout frame after Flickity replaces its cells.
            galleryLayoutFrame = window.requestAnimationFrame(function() {
                productSlideshow.reposition();
                productSlideshow.resize();
                productSlideshow.select(targetIndex, false, true);
                productSlideshow.positionSliderAtSelected();
                syncSelectedDot();
                galleryLayoutFrame = null;
            });
        });
    };

    const syncSelectedDot = function() {
        const productSlideshow = getProductSlideshow();

        if (!productSlideshow || !productSlideshow.selectedElement) {
            return;
        }

        const selectedMediaId = productSlideshow.selectedElement.dataset.mediaId;
        dots.forEach(function(dot) {
            dot.classList.toggle('is-selected', dot.dataset.mediaId === selectedMediaId);
        });
    };

    const updateGallery = function(colorName, variantSku, featuredMediaId, selectMainImage) {
        const matchingThumbnails = thumbnails.filter(function(thumbnail) {
            return matchesVariant(thumbnail, colorName, variantSku);
        });
        const hasVariantMedia = matchingThumbnails.length > 0;
        const preferredThumbnail = matchingThumbnails.find(function(thumbnail) {
            return thumbnail.dataset.mediaId === featuredMediaId;
        }) || matchingThumbnails[0];
        const selectedMediaId = preferredThumbnail ? preferredThumbnail.dataset.mediaId : featuredMediaId;

        thumbnails.forEach(function(thumbnail) {
            thumbnail.classList.toggle('hidden-tablet-and-up', hasVariantMedia && !matchesVariant(thumbnail, colorName, variantSku));
        });

        const visibleDots = dots.filter(function(dot) {
            return !hasVariantMedia || matchesVariant(dot, colorName, variantSku);
        });

        dots.forEach(function(dot) {
            const isVisible = visibleDots.indexOf(dot) !== -1;
            dot.classList.toggle('hidden-phone', !isVisible);
            dot.classList.toggle('hidden-tablet', !isVisible);
            dot.classList.toggle('hidden-lap', !isVisible);
        });

        visibleDots.forEach(function(dot, index) {
            dot.dataset.index = index;
        });

        if (pocketViewport.matches) {
            const visibleSlides = hasVariantMedia ? slides.filter(function(slide) {
                return matchesVariant(slide, colorName, variantSku);
            }) : slides;

            replaceSlides(visibleSlides, selectedMediaId);
            syncSelectedDot();
        } else if (selectMainImage && preferredThumbnail) {
            preferredThumbnail.click();
        }
    };

    const attachSlideshowListener = function() {
        const productSlideshow = getProductSlideshow();

        if (productSlideshow && !slideshowListenerAttached) {
            productSlideshow.on('select', syncSelectedDot);
            slideshowListenerAttached = true;
        }
    };

    product.addEventListener('variant:changed', function(event) {
        const variant = event.detail.variant;
        const optionIndex = Number(targetOption.replace('option', '')) - 1;
        const colorName = variant[targetOption] || (variant.options && variant.options[optionIndex]);

        if (colorName) {
            scheduleGalleryUpdate(variant, colorName);
        }
    });

    const handleViewportChange = function(event) {
        if (event.matches) {
            updateGallery(activeVariant.colorName, activeVariant.sku, activeVariant.featuredMediaId, false);
        } else {
            replaceSlides(slides, activeVariant.featuredMediaId);
        }
    };

    if (pocketViewport.addEventListener) {
        pocketViewport.addEventListener('change', handleViewportChange);
    } else {
        pocketViewport.addListener(handleViewportChange);
    }

    const initializeSlideshow = function(attempt) {
        if (getProductSlideshow()) {
            attachSlideshowListener();
            updateGallery(activeVariant.colorName, activeVariant.sku, activeVariant.featuredMediaId, false);
        } else if (attempt < 60) {
            window.requestAnimationFrame(function() {
                initializeSlideshow(attempt + 1);
            });
        }
    };

    initializeSlideshow(0);
}

function initializeProductCompareTable() {
    document.addEventListener('submit', function(event) {
        const form = event.target;

        if (!form.matches('.ProductCompare__Form')) {
            return;
        }

        event.preventDefault();

        const button = form.querySelector('.ProductForm__AddToCart');
        const variantInput = form.querySelector('[name="id"]');
        const quantityInput = form.querySelector('[name="quantity"]');
        const variantId = Number(variantInput && variantInput.value);
        const quantity = Number(quantityInput && quantityInput.value) || 1;
        const existingError = form.querySelector('.ProductForm__Error');

        if (!variantId || !button) {
            return;
        }

        if (existingError) {
            existingError.remove();
        }

        button.setAttribute('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch(window.routes.cartAddUrl + '.js', {
            body: JSON.stringify({ id: variantId, quantity: quantity }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(function(response) {
                return response.json().then(function(content) {
                    if (!response.ok) {
                        throw new Error(content.description || 'Unable to add this product to the cart.');
                    }

                    form.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: { variant: content, quantity: quantity }
                    }));
                });
            })
            .catch(function(error) {
                const errorMessage = document.createElement('span');
                errorMessage.className = 'ProductForm__Error Alert Alert--error';
                errorMessage.setAttribute('role', 'alert');
                errorMessage.textContent = error.message;
                button.insertAdjacentElement('afterend', errorMessage);
            })
            .then(function() {
                button.removeAttribute('disabled');
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
    }, true);
}

function initializeProductCompareNotifications() {
    const dialog = document.querySelector('[data-product-compare-notify-dialog]');

    if (!dialog) {
        return;
    }

    const form = dialog.querySelector('[data-product-compare-notify-form]');
    const heading = dialog.querySelector('[data-product-compare-notify-heading]');
    const message = dialog.querySelector('[data-product-compare-notify-message]');
    const email = form.elements.email;
    const variantId = form.elements.variant_id;

    document.querySelectorAll('[data-product-compare-notify]').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            heading.textContent = trigger.dataset.productTitle;
            variantId.value = trigger.dataset.variantId;
            message.hidden = true;
            message.textContent = '';
            dialog.showModal();
            email.focus();
        });
    });

    dialog.querySelector('[data-product-compare-notify-close]').addEventListener('click', function() {
        dialog.close();
    });

    dialog.addEventListener('click', function(event) {
        if (event.target === dialog) {
            dialog.close();
        }
    });

    form.addEventListener('submit', function(event) {
        event.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        submitButton.disabled = true;
        message.hidden = true;

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=YqSCEn', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Klaviyo-Onsite': '1',
                revision: '2024-02-15'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: { email: email.value }
                            }
                        },
                        channels: ['EMAIL']
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: '$shopify:::$default:::' + variantId.value
                            }
                        }
                    }
                }
            })
        })
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Unable to submit your request. Please try again.');
                }

                form.reset();
                message.textContent = "You're in! We'll let you know when it's back.";
                message.hidden = false;
            })
            .catch(function(error) {
                message.textContent = error.message;
                message.hidden = false;
            })
            .then(function() {
                submitButton.disabled = false;
            });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    toggleSummaryBullets();
    toggleVariantThumbnails();
    initializeProductCompareTable();
    initializeProductCompareNotifications();
});
